import styled, { css } from "styled-components";

export const ProjectLayoutDiv = styled.section`
  background-color: #02283c;
  ${({ sideBar }) =>
    sideBar &&
    css`
      filter: blur(4px);
    `}

  .gradient {
    height: 4rem;
    width: 100%;
  }
  .text-zone {
    width: calc(100% -9rem);
    background-color: #02283c;
    margin-left: 9rem;
    padding: 0 4rem;
    position: relative;
    transform: translateY(60%);
    opacity: 0;
    z-index: 3;
    -webkit-transition: all 1.6s cubic-bezier(0.39, 0.575, 0.565, 1);
    transition: all 1.6s cubic-bezier(0.39, 0.575, 0.565, 1);
    h1 {
      color: #3bcfe3;
      font-size: 3.9rem;
      line-height: 53px;
      font-family: "Lato", sans-serif;
      font-weight: 500;

      &:before {
        content: "<h1>";
        font-family: "La Belle Aurore", cursive;
        color: #3bcfe3;
        opacity: 0.3;
        font-size: 18px;
        position: absolute;
        margin-top: -15px;
        left: 3rem;
      }

      &:after {
        content: "<h1/>";
        font-family: "La Belle Aurore", cursive;
        font-size: 18px;
        position: absolute;
        margin-top: 18px;
        margin-left: 20px;
        animation: fadeIn 1s 1.7s backwards;
        color: #3bcfe3;
        opacity: 0.3;
      }
    }
    p {
      margin-top: 1rem;
      max-width: 42rem;
      width: 100%;
      color: #d6d6d6;
      font-size: clamp(1rem, 2.5vw, 1.2rem);
      line-height: 26px;
      letter-spacing: 0.05rem;
      word-spacing: 0.15rem;
      font-weight: 400;
      a {
        color: #3bcfe3;
        text-decoration: none;
        &:hover {
          opacity: 0.6;
        }
      }
    }

    @media (max-width: 900px) {
      margin: unset;
      padding: 0 3rem;
    }
    @media (max-width: 588px) {
      margin: unset;
      padding: 0 2rem;
    }
    @media (max-width: 400px) {
      margin: unset;
      padding: 0 1.2rem;
    }
    @media (max-width: 330px) {
      padding: 5rem 1.3rem;
    }

    ${({ isVisible }) =>
      isVisible &&
      css`
        -webkit-transition: all 1.6s cubic-bezier(0.39, 0.575, 0.565, 1);
        transition: all 1.6s cubic-bezier(0.39, 0.575, 0.565, 1);
        transform: translateY(0%);
        opacity: 1;
      `}
  }
  .top-gradient {
    background: rgb(2, 40, 60);
    background: linear-gradient(
      180deg,
      rgba(2, 40, 60, 1) 100%,
      rgba(2, 40, 60, 0.5662640056022409) 0%
    );
  }
`;
